import { Action, createReducer, on } from '@ngrx/store';
import { IAsqFundItem } from '../models/asq-funds.model';
import * as asqFundsActions from '../actions/asq-funds.actions';

export const asqFundsFeatureKey = 'asqFunds';

export interface AsqFundsState {
  loadAsqFundsResponse: IAsqFundItem[];
  loadAsqFundsFailure: Error | any;
}

export const initialState: AsqFundsState = {
  loadAsqFundsResponse: undefined,
  loadAsqFundsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(asqFundsActions.loadAsqFundsSuccess, (state, action) => ({
    ...state,
    loadAsqFundsResponse: action.response
  })),
  on(asqFundsActions.loadAsqFundsFailure, (state, action) => ({
    ...state,
    loadAsqFundsFailure: action.error
  }))
);

export const getAsqFunds = (state: AsqFundsState) => state.loadAsqFundsResponse;
